<template>
  <div>
    <header class="header">
      <div>
        <div class="header__logo">
          <img src="./../../assets/images/hrdesk-logo-dark-beta.png" alt="logo" />
        </div>
        <div class="header__nav">
          <div class="header__navbar">
            <div class="header__navbar--profile">
              <div class="header__navbar--profile-name">{{ firstname }}</div>
              <div class="header__navbar--profile-avatar">
                <img src="./../../assets/images/user.svg" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="header__mobile">
          <div class="header__navbar">
            <div class="header__navbar--profile">
              <div class="header__navbar--profile-name" @click="showMobileMenu">
                Menu
                <font-awesome-icon icon="bars" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="sidebar_mobile" v-if="mobile">
      <div class="sidebar__section">
        <div class="sidebar__section--nav" v-if="item === 'profile'">Profile</div>
        <div class="sidebar__section--nav" v-if="item !== 'profile'" @click="showMobileMenu">
          <routerLink to="/jobseeker-profile" active-class="active__link">Profile</routerLink>
        </div>

        <div class="sidebar__section--nav" v-if="item === 'jobs'">View Available Jobs</div>
        <div class="sidebar__section--nav" v-if="item !== 'jobs'" @click="showMobileMenu">
          <routerLink to="/jobseeker-jobs" active-class="active__link">View Available Jobs</routerLink>
        </div>

        <div class="sidebar__section--nav" v-if="item === 'msg'">Message</div>
        <div class="sidebar__section--nav" v-if="item !== 'msg'" @click="showMobileMenu">
          <routerLink to="/jobseeker-profile" active-class="active__link">Message</routerLink>
        </div>
        <div class="sidebar__section--nav">
          <span @click="logOut">Logout</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../store/constant";
export default {
  name: "JobseekerHeader",
  props: ["item"],
  data() {
    return {
      mobile: false,
      firstname: ""
    };
  },
  methods: {
    showMobileMenu() {
      if (this.mobile) {
        this.mobile = false;
        return;
      }
      this.mobile = true;
    },
    logOut() {
      this.showMobileMenu();
      this.$store.dispatch(types.AUTH_LOGOUT).then(() => {
        this.$router.push("/login");
      });
    }
  },
  created() {
    this.firstname = this.$store.getters.currentAuthUser.firstname;
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999999;
  height: 80px;
  padding: 0 20px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;

  @media (max-width: 400px) {
    padding: 10px 5px;
  }

  >div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;

    >.header__logo {
      max-width: 150px;
      padding-top: 0;

      >a {
        img {
          width: 100%;
        }
      }
    }

    >.header__nav {
      width: 200px;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-end;
      align-content: center;
      display: flex;

      @media (max-width: 1000px) {
        display: none;
      }

      >.header__navbar {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-end;
        align-content: center;

        >.header__navbar--wallet {
          width: calc(100% - 230px);
          font-size: 1.042vw;
          font-weight: 200;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.17;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          text-align: right;

          >span {
            font-weight: 600;
            color: #e57414;
            font-size: 12px;
          }

          ::placeholder {
            color: #caced5;
            opacity: 1;
          }

          ::-ms-input-placeholder {
            color: #caced5;
          }

          ::-ms-input-placeholder {
            color: #caced5;
          }
        }

        >.header__navbar--alert {
          width: 70px;
          padding: 0 10px;

          @media (max-width: 1400px) {
            width: 60px;
          }

          >div {
            border-left: 1px solid #ebebf2;
            border-right: 1px solid #ebebf2;
            height: 50px;
            text-align: center;
            font-size: 50px;
            padding-top: 18px;
            color: #bcbccb;
            position: relative;

            >div {
              position: absolute;
              top: 13px;
              right: 12px;
              width: 15px;
              height: 15px;
              background: #ffc06a;
              border-radius: 60px;
              overflow: hidden;
              border: 3px solid #fff;
              cursor: pointer;

              @media (max-width: 1400px) {
                right: 6px;
              }
            }
          }
        }

        >.header__navbar--profile {
          width: 160px;
          height: 50px;
          position: relative;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          >.header__navbar--profile-name {
            width: 100px;
            height: 30px;
            cursor: pointer;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.43;
            letter-spacing: normal;
            color: #707070;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-top: 10px;
          }

          >.header__navbar--profile-avatar {
            width: 30px;
            height: 30px;
            border-radius: 60px;
            text-align: center;
            overflow: hidden;
            cursor: pointer;
          }

          >.header__navbar--profile-dropdown {
            position: absolute;
            top: 50px;
            left: 0;
            width: 100%;
            overflow: hidden;
            background: #fbfafa;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            z-index: 9;

            >div {
              height: 30px;
              padding-left: 20px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 12px;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: flex-start;
              align-content: center;

              >a {
                text-decoration: none;
                color: #000;
              }
            }
          }
        }
      }
    }

    >.header__mobile {
      width: 70px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-end;
      align-content: center;
      display: none;

      @media (max-width: 1000px) {
        display: block;
      }
    }
  }
}

.sidebar_mobile {
  position: fixed;
  top: 85px;
  left: 0;
  width: 200px;
  height: 100%;
  background-color: #fff;
  padding-top: 20px;
  padding-left: 15px;
  padding-bottom: 20px;
  display: none;

  @media (max-width: 1000px) {
    display: block;
  }

  .sidebar__section {
    padding-bottom: 10px;

    .sidebar__section--nav {
      padding-bottom: 25px;
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      text-align: left;
      color: #e57414;

      >span {
        color: #000000;
        cursor: pointer;

        &:hover {
          color: #e57414;
        }
      }

      >p {
        color: #e57414;
        cursor: pointer;
        margin: 0;
      }

      .sidebar__section--nav-item {
        padding-left: 15px;

        >div {
          padding-top: 20px;
          color: #000;

          >span {
            color: #e57414;
          }
        }
      }

      a {
        color: #000;
        text-decoration: none;

        &:hover {
          color: #e57414;
        }
      }
    }
  }
}
</style>
